import {
    NEW_USER_START,
    NEW_USER_SUCCESS,
    NEW_USER_FAIL,
} from './ActionsTypes';
// alerts
import Swal from 'sweetalert2';
// axios
import clienteAxios from '../../config/Axios';

export function NewUserAction(body, navigate, token, onHide, setFormData, update, setUpdate) {
    return (dispatch) => {
        dispatch(NewUserStart())

        const config = { headers: { 'Authorization': "Bearer " + token } };//confi axios

        clienteAxios.post('/api/users/new-user', body, config)
            .then((res) => {
                // console.log(res.data)
                Swal.fire({ icon: 'success', title: 'Exito', text: 'Usuario creado con éxito' })
                dispatch(NewUserSuccess())
                setFormData({
                    firstname: "",
                    lastname: "",
                    dni: "",
                    creditIDId: "",
                    phone: "",
                    password: "",
                    confirmPassword: "",
                    isActive: false
                })
                setUpdate(update + 1)
                onHide()
            })
            .catch(error => {
                dispatch(NewUserFail())
                console.log(error.response)
                if (!error.response) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error de conexión.' })
                } else if (error.response.status === 400) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Datos invalidos' })
                } else {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error, intente de nuevo' })
                }
            })
    }
}



export const NewUserStart = () => {
    return {
        type: NEW_USER_START
    };
};

export const NewUserSuccess = () => ({
    type: NEW_USER_SUCCESS
})

export const NewUserFail = () => ({
    type: NEW_USER_FAIL,
})
